import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  allTasks: [],
  params: {},
  byId: {},
  actionsloading: false,
});

export function upcomingTasksReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_UPCOMING_TASKS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_UPCOMING_TASKS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
        allTasks: action.payload,
        username: action.payload.upcoming_tasks.length > 0 ? action.payload.upcoming_tasks[0].username : undefined,
        upcoming_tasks: action.payload.upcoming_tasks,
        student_list: action.payload.student_list,
      };
    default:
      return state;
  }
}
